import React from 'react';
// @ts-ignore
import variables from 'styles/_variables.scss';
import { IIconProps } from './IIconProps';

export const PastIcon = ({ iconClass = '', title = '' }: IIconProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			version="1.1"
			viewBox="0 0 26 26"
			className={iconClass}
			fill="none"
		>
			{title && <title>{title}</title>}
			<path
				d="M0.8125 3.98096V11.2935H8.125"
				stroke={variables.bgIconChevron}
			/>
			<path
				d="M14.0967 8.85645L14.0967 14.9502"
				stroke={variables.bgIconChevron}
			/>
			<path
				d="M19.8252 14.8281L13.7314 14.8281"
				stroke={variables.bgIconChevron}
			/>
			<path
				d="M3.87156 17.3873C5.49495 21.9951 9.96999 24.9738 14.8473 24.6931C19.7246 24.4124 23.8283 20.9399 24.9123 16.1763C25.9964 11.4128 23.7993 6.50645 19.5238 4.14288C15.2482 1.77931 9.92489 2.52828 6.4675 5.97982L0.8125 11.2936"
				stroke={variables.bgIconChevron}
			/>
		</svg>
	);
};
